export default "__VITE_ASSET__BuaRA5TT__"